<div class="flex flex-col container box-border items-center gap-6 my-14 p-14">
    <div>
        <img width="360" src="/assets/images/error-403.svg" />
    </div>
    <div class="flex justify-center" data-testid="error-page-title">
        <strong class="ca-headline-1 mb-0">{{ 'COMMON.ERRORS.403.TITLE' | translate }}</strong>
    </div>
    <div class="flex flex-col items-center gap-6 mt-6">
        <div>{{ 'COMMON.ERRORS.403.NO_ACCESS' | translate }}</div>

        <div class="flex justify-center">
            <a href="https://viguide-planning-staging.viessmann-climatesolutions.com" data-testid="error-page-link">
                <button mat-stroked-button class="ca-button mt-auto">
                    <span class="button-title">{{ 'COMMON.ERRORS.403.LINK' | translate }}</span>
                    <ca-icon icon="arrow-outward" class="ca-icon-s"></ca-icon>
                </button>
            </a>
        </div>
    </div>
</div>
